import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { deletePermission, updatePermission } from "store/actions";
import CreatePermission from "./CreatePermission";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import TableContainer from '../../components/Common/DataTableContainer';

import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const PermissionTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const permissions = JSON.parse(localStorage?.getItem('permissions'));


  const handleDelete = (permissionId) => {
    dispatch(deletePermission(permissionId));
    setDeleteId("");
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(
    () => [
      {
        header: "Permission Name",
        accessorKey: "permissionName",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <span
          >
            {row.original.permissionName}
          </span>
        ),
      },
      {
        header: "Page URL",
        accessorKey: "pageUrl",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Permission Group",
        accessorKey: "permissionGroup",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Actions",
        id: "actions", 
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData);
            setIsOpen(true); 
          };

          const handleDelete = () => {
            const rowData = row.original;
            setDeleteId(rowData.permissionId); 
            setOpenModal(true);
          };

          return (
            <div className="d-flex gap-2">
              {permissions?.map(item => item?.permissionName)?.includes("Edit Permissions") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions?.map(item => item?.permissionName)?.includes("Delete Permissions") && <Button
                color="danger"
                onClick={handleDelete}
                className="mr-2"
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
    ],
    []
  );

  const handleSubmit = (data) => {
    dispatch(updatePermission(data)); 
  };

  const handleClose = () => {
    setIsOpen(false); 
  };

  // Meta title
  document.title = "Permission Management | Admin Dashboard";

  return (
    <>
      {/* Confirmation Modal for Deleting Permission */}
      <ConfirmationModal
        okText={"Confirm"}
        onCancel={() => {
          setDeleteId("");
          setOpenModal(false);
        }}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Permission"
        content="Are you sure you want to delete this permission?"
      />

      {/* Create/Edit Permission Modal */}
      <CreatePermission
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <div className="">
        <div className="container-fluid">
          {/* Data Table Container to Display Permissions */}
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Permissions"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default PermissionTable;
